export default "__VITE_ASSET__D$OfyJfK__"